{
  "version": 1,
  "asset_id": "078bec3a-5301-4505-b4ce-f121b55d741f",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/078bec3a-5301-4505-b4ce-f121b55d741f/bypass-revision-completed-pouch-es-320.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/078bec3a-5301-4505-b4ce-f121b55d741f/bypass-revision-completed-pouch-es-320.webp",
  "original_filename": "bypass-revision-completed-pouch-es-320.webp",
  "size": 10296,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:39Z"
}
